import React from "react";

interface ILinkProps {
  label?: string;
  onClick?: (value: any) => void;
}

type Props = ILinkProps;

export class Link extends React.PureComponent<Props> {
  render() {
    const { label, onClick } = this.props;
    return (
      <a href="#" className="el-pagination-link" onClick={onClick}>
        {label}
      </a>
    );
  }
}
